import React from 'react';
import DailyBarChart from '../DailyBarChart';

export default class LoginsCard extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log(this.props)

		return (
			<div className="LoginsCard">
				<h5 className="card-title">{I18n.t('admin.logins')}</h5>
				<div className="row">
					<div className="col-12">
						<DailyBarChart
							endpoint={this.props.endpoint}
							title={I18n.t('admin.logins')}
							// data={[
							// 	{
							// 		date: '01/01/2021',
							// 		value: 218
							// 	},
							// 	{
							// 		date: '01/02/2021',
							// 		value: 142
							// 	},
							// 	{
							// 		date: '01/03/2021',
							// 		value: 85
							// 	},
							// 	{
							// 		date: '01/04/2021',
							// 		value: 125
							// 	},
							// 	{
							// 		date: '01/05/2021',
							// 		value: 180
							// 	},
							// 	{
							// 		date: '01/06/2021',
							// 		value: 168
							// 	},
							// 	{
							// 		date: '01/07/2021',
							// 		value: 89
							// 	},
							// 	{
							// 		date: '01/08/2021',
							// 		value: 77
							// 	},
							// 	{
							// 		date: '01/09/2021',
							// 		value: 62
							// 	},
							// 	{
							// 		date: '01/10/2021',
							// 		value: 28
							// 	},
							// 	{
							// 		date: '01/11/2021',
							// 		value: 55
							// 	},
							// 	{
							// 		date: '01/12/2021',
							// 		value: 177
							// 	},
							// 	{
							// 		date: '01/13/2021',
							// 		value: 88
							// 	},
							// 	{
							// 		date: '01/14/2021',
							// 		value: 44
							// 	},
							// 	{
							// 		date: '01/15/2021',
							// 		value: 201
							// 	},
							// 	{
							// 		date: '01/16/2021',
							// 		value: 59
							// 	},
							// 	{
							// 		date: '01/17/2021',
							// 		value: 142
							// 	},
							// 	{
							// 		date: '01/18/2021',
							// 		value: 132
							// 	},
							// 	{
							// 		date: '01/19/2021',
							// 		value: 138
							// 	},
							// 	{
							// 		date: '01/20/2021',
							// 		value: 35
							// 	},
							// 	{
							// 		date: '01/21/2021',
							// 		value: 68
							// 	},
							// 	{
							// 		date: '01/22/2021',
							// 		value: 125
							// 	},
							// 	{
							// 		date: '01/23/2021',
							// 		value: 22
							// 	},
							// 	{
							// 		date: '01/24/2021',
							// 		value: 10
							// 	},
							// 	{
							// 		date: '01/25/2021',
							// 		value: 87
							// 	},
							// 	{
							// 		date: '01/26/2021',
							// 		value: 188
							// 	},
							// 	{
							// 		date: '01/27/2021',
							// 		value: 168
							// 	},
							// 	{
							// 		date: '01/28/2021',
							// 		value: 142
							// 	},
							// 	{
							// 		date: '01/29/2021',
							// 		value: 111
							// 	},
							// 	{
							// 		date: '01/30/2021',
							// 		value: 145
							// 	},
							// 	{
							// 		date: '01/31/2021',
							// 		value: 166
							// 	},
							// 	{
							// 		date: '02/01/2021',
							// 		value: 218
							// 	},
							// 	{
							// 		date: '02/02/2021',
							// 		value: 44
							// 	},
							// 	{
							// 		date: '02/03/2021',
							// 		value: 99
							// 	},
							// 	{
							// 		date: '02/04/2021',
							// 		value: 185
							// 	}
							// ]}
						/>
					</div>
				</div>
			</div>
		);
	}
}
